import { ref } from '@vue/composition-api';
import { weeklyChallengeService } from '@/bundles/ActivityGroup/factory/weeklyChallengeServiceFactory';

export function useWeeklyChallenge() {
  const weeklyChallenges = ref<any[]>([]);
  const loading = ref(false);

  async function fetchWeeklyChallenges() {
    loading.value = true;
    try {
      const response = await weeklyChallengeService.getList({});
      weeklyChallenges.value = response.data;
    } catch (err) {
      throw err;
    } finally {
      loading.value = false;
    }
  }

  const convertToFormData = (challenge: any): FormData => {
    const formData = new FormData();
    formData.append('name', challenge.name);
    formData.append('homework_id', challenge.homework_id);
    if (challenge.file) {
      formData.append('image', challenge.file!);
    }
    return formData;
  };

  async function createWeeklyChallenge(data: any) {
    loading.value = true;
    try {
      const formData = convertToFormData(data);
      const response = await weeklyChallengeService.createChallenge(formData);
      weeklyChallenges.value.push(response.data);
      return response.data;
    } catch (err) {
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function updateWeeklyChallenge(id: number, data: any) {
    loading.value = true;
    try {
      const formData = convertToFormData(data);
      const response = await weeklyChallengeService.updateChallenge(id, formData);
      const index = weeklyChallenges.value.findIndex(challenge => challenge.id === id);
      if (index !== -1) {
        weeklyChallenges.value[index] = response.data;
      }
      return response.data;
    } catch (err) {
      throw err;
    } finally {
      loading.value = false;
    }
  }

  return {
    weeklyChallenges,
    loading,
    fetchWeeklyChallenges,
    createWeeklyChallenge,
    updateWeeklyChallenge,
  };
}
